/**********
 * 公共函数库
 *********/

/**
 * 获取婚姻状态名称
 * @param value
 * @returns {string}
 */
export function getMarriageName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return '未婚';
    } else if (marker === 2) {
        return '离异';
    } else if (marker === 4) {
        return '丧偶';
    }
    return '不限';
}

export function getMarriageState(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return '未婚';
    } else if (marker === 2) {
        return '离异';
    } else if (marker === 4) {
        return '丧偶';
    }else if (marker === 3) {
        return '未婚、离异';
    }else if (marker === 5) {
        return '未婚、丧偶';
    }else if (marker === 6) {
        return '离异、丧偶';
    }else if (marker === 7) {
        return '不限';
    }
    return '不限';
}


/**
 * 获取独生子女名称
 * @param value
 * @returns {string}
 */
export function getOnlySonName(value) {
    let marker = parseInt(value);
    if (marker === 0) {
        return "否";
    } else if (marker === 1) {
        return "是";
    }
    return '不限';
}


/**
 * 获取学历名称
 * @param value
 * @returns {string}
 */
export function getEducationName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return '无学历';
    } else if (marker === 2) {
        return '小学';
    } else if (marker === 4) {
        return '初中';
    } else if (marker === 8) {
        return '中专';
    } else if (marker === 16) {
        return '高中';
    } else if (marker === 32) {
        return '大专';
    } else if (marker === 64) {
        return '本科';
    } else if (marker === 128) {
        return '硕士';
    } else if (marker === 256) {
        return '博士';
    }
    return '无学历';
}

/**
 * 获取收入名称
 * @param value
 * @returns {string}
 */
export function getSalaryName(value) {
    let marker = parseInt(value);
    if (marker === 1000) {
        return '1000';
    } else if (marker === 2000) {
        return '2000';
    } else if (marker === 3000) {
        return '3000';
    } else if (marker === 4000) {
        return '4000';
    } else if (marker === 5000) {
        return '5000';
    } else if (marker === 6000) {
        return '6000';
    } else if (marker === 7000) {
        return '7000';
    } else if (marker === 8000) {
        return '8000';
    } else if (marker === 9000) {
        return '9000';
    } else if (marker === 10000) {
        return '1W';
    } else if (marker === 15000) {
        return '1.5W';
    } else if (marker === 20000) {
        return '2W';
    } else if (marker === 30000) {
        return '3W';
    } else if (marker === 40000) {
        return '4W';
    } else if (marker === 50000) {
        return '5W';
    } else if (marker === 70000) {
        return '7W';
    } else if (marker === 100000) {
        return '10W';
    } else if (marker === 200000) {
        return '20W';
    } else if (marker === 500000) {
        return '50W';
    } else if (marker === 1000000) {
        return '100W';
    } else if (marker === 1500000) {
        return '100W以上';
    }
    return '不限';
}

export function getCarName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return '无车';
    } else if (marker === 2) {
        return '需要时购车';
    } else if (marker === 4) {
        return '已购车';
    }
    return '不限';
}

export function getCarState(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return '无车';
    } else if (marker === 2) {
        return '需要时购车';
    } else if (marker === 4) {
        return '已购车';
    } else if (marker === 3) {
        return '无车、需要时购车';
    } else if (marker === 5) {
        return '无车、已购车';
    } else if (marker === 6) {
        return '需要时购车、已购车';
    } else if (marker === 7) {
        return '不限';
    }
    return '不限';
}


export function getCarPriceName(value) {
    let marker = parseInt(value);
    if (marker === 5) {
        return '10W以下';
    } else if (marker === 15) {
        return '10-20W';
    } else if (marker === 25) {
        return '20-30W';
    } else if (marker === 40) {
        return '30-50W';
    } else if (marker === 75) {
        return '50-100W';
    } else if (marker === 150) {
        return '100W以上';
    }
    return '不限';
}


export function getHouseName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return '无房';
    } else if (marker === 2) {
        return '需要时购房';
    } else if (marker === 4) {
        return '自建房';
    } else if (marker === 8) {
        return '商品房';
    } else if (marker === 16) {
        return '自建别墅';
    } else if (marker === 32) {
        return '商品别墅';
    }
    return '不限';
}

export function getHousePrice(value) {
    let marker = parseInt(value);
    if (marker === 10) {
        return '20W以下';
    } else if (marker === 25) {
        return '20-30W';
    } else if (marker === 40) {
        return '30-50W';
    } else if (marker === 75) {
        return '50-100W';
    } else if (marker === 125) {
        return '100-150W';
    } else if (marker === 175) {
        return '150-200W';
    } else if (marker === 250) {
        return '200-300W';
    } else if (marker === 400) {
        return '300-500W';
    } else if (marker === 550) {
        return '500W以上';
    }
    return '不限';
}

export function getChildrenName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return '无子女';
    } else if (marker === 2) {
        return '带一男孩';
    } else if (marker === 4) {
        return '带俩男孩';
    } else if (marker === 8) {
        return '带三男孩';
    } else if (marker === 16) {
        return '带一女孩';
    } else if (marker === 32) {
        return '带俩女孩';
    } else if (marker === 64) {
        return '带三女孩';
    }
    return '不限';
}


export function getSexName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "男";
    } else if (marker === 2) {
        return "女";
    }
    return '不限';
}


export function getLoveStatusName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "单身中";
    } else if (marker === 2) {
        return "热恋中";
    } else if (marker === 3) {
        return "已脱单";
    }
    return '不限';
}


export function getHealthName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "健康";
    } else if (marker === 2) {
        return "残疾";
    } else if (marker === 4) {
        return "聋哑人";
    } else if (marker === 8) {
        return "盲人";
    }
    return '不限';
}

/**
 * 择偶条件-健康
 * @param value
 * @returns {string}
 */
export function getHealthState(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "健康";
    } else if (marker === 2) {
        return "残疾";
    } else if (marker === 4) {
        return "聋哑人";
    } else if (marker === 8) {
        return "盲人";
    } else if (marker === 3) {
        return "健康、残疾";
    } else if (marker === 5) {
        return "健康、聋哑人";
    } else if (marker === 9) {
        return "健康、盲人";
    } else if (marker === 6) {
        return "残疾、聋哑人";
    } else if (marker === 10) {
        return "残疾、盲人";
    } else if (marker === 12) {
        return "聋哑人、盲人";
    } else if (marker === 7) {
        return "健康、残疾、聋哑人";
    } else if (marker === 11) {
        return "健康、残疾、盲人";
    } else if (marker === 14) {
        return "残疾、聋哑人、盲人";
    } else if (marker === 15) {
        return "不限";
    }
    return '不限';
}


/**
 * 获取房子状态
 * house': 1="无房", 2="需要时购房", 4="自建房", 8="商品房", 16="自建别墅", 32="商品别墅"
 */
export function getHouseState(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "无房";
    } else if (marker === 2) {
        return "需要时购房";
    } else if (marker === 4) {
        return "自建房";
    } else if (marker === 8) {
        return "商品房";
    } else if (marker === 16) {
        return "自建别墅";
    } else if (marker === 32) {
        return "商品别墅";
    } else if (marker === 3) {
        return "无房、需要时购房";
    } else if (marker === 5) {
        return "无房、自建房";
    } else if (marker === 9) {
        return "无房、商品房";
    } else if (marker === 17) {
        return "无房、自建别墅";
    } else if (marker === 33) {
        return "无房、商品别墅";
    } else if (marker === 6) {
        return "需要时购房、自建房";
    } else if (marker === 10) {
        return "需要时购房、商品房";
    } else if (marker === 18) {
        return "需要时购房、自建别墅";
    } else if (marker === 34) {
        return "需要时购房、商品别墅";
    } else if (marker === 12) {
        return "自建房、商品房";
    } else if (marker === 20) {
        return "自建房、自建别墅";
    } else if (marker === 36) {
        return "自建房、商品别墅";
    } else if (marker === 24) {
        return "商品房、自建别墅";
    } else if (marker === 40) {
        return "商品房、商品别墅";
    } else if (marker === 48) {
        return "自建别墅、商品别墅";
    } else if (marker === 7) {
        return "无房、需要时购房、自建房";
    } else if (marker === 11) {
        return "无房、需要时购房、商品房";
    } else if (marker === 19) {
        return "无房、需要时购房、自建别墅";
    } else if (marker === 35) {
        return "无房、需要时购房、商品别墅";
    } else if (marker === 13) {
        return "无房、自建房、商品房";
    } else if (marker === 21) {
        return "无房、自建房、自建别墅";
    } else if (marker === 37) {
        return "无房、自建房、商品别墅";
    } else if (marker === 25) {
        return "无房、商品房、自建别墅";
    } else if (marker === 41) {
        return "无房、商品房、商品别墅";
    } else if (marker === 49) {
        return "无房、自建别墅、商品别墅";
    } else if (marker === 14) {
        return "需要时购房、自建房、商品房";
    } else if (marker === 22) {
        return "需要时购房、自建房、自建别墅";
    } else if (marker === 38) {
        return "需要时购房、自建房、商品别墅";
    } else if (marker === 26) {
        return "需要时购房、商品房、自建别墅";
    } else if (marker === 42) {
        return "需要时购房、商品房、商品别墅";
    } else if (marker === 50) {
        return "需要时购房、自建别墅、商品别墅";
    } else if (marker === 28) {
        return "自建房、商品房、自建别墅";
    } else if (marker === 44) {
        return "自建房、商品房、商品别墅";
    } else if (marker === 52) {
        return "自建房、自建别墅、商品别墅";
    } else if (marker === 15) {
        return "无房、需要时购房、自建房、商品房";
    } else if (marker === 23) {
        return "无房、需要时购房、自建房、自建别墅";
    } else if (marker === 39) {
        return "无房、需要时购房、自建房、商品别墅";
    } else if (marker === 30) {
        return "需要时购房、自建房、商品房、自建别墅";
    } else if (marker === 46) {
        return "需要时购房、自建房、商品房、商品别墅";
    } else if (marker === 60) {
//            return "自建房、商品房、自建别墅、商品别墅";
        return "已购房";
    } else if (marker === 31) {
        return "无房、需要时购房、自建房、商品房、自建别墅";
    } else if (marker === 47) {
        return "无房、需要时购房、自建房、商品房、商品别墅";
    } else if (marker === 62) {
//            return "需要时购房、自建房、商品房、自建别墅、商品别墅";
        return "需要时购房、已购房";

    } else if (marker === 63) {
        return "不限";
    }
    return '不限';
}


/**
 * 获取子女状态
 * 'children_info': 1="无",2="带一男孩",4="带俩男孩",8="带三男孩",16="带一女孩",32="带俩女孩",64="带三女孩"
 */
export function getChildrenState(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "无";
    } else if (marker === 2) {
        return "带孩(一男孩)";
    } else if (marker === 4) {
        return "带孩(俩男孩)";
    } else if (marker === 8) {
        return "带孩(三男孩)";
    } else if (marker === 16) {
        return "带孩(一女孩)";
    } else if (marker === 32) {
        return "带孩(俩女孩)";
    } else if (marker === 64) {
        return "带孩(三女孩)";
    } else if (marker === 18) {
        return "带孩(一男孩、一女孩)";
    } else if (marker === 34) {
        return "带孩(一男孩、俩女孩)";
    } else if (marker === 66) {
        return "带孩(一男孩、三女孩)";
    } else if (marker === 20) {
        return "带孩(俩男孩、一女孩)";
    } else if (marker === 36) {
        return "带孩(俩男孩、俩女孩)";
    } else if (marker === 68) {
        return "带孩(俩男孩、三女孩)";
    } else if (marker === 24) {
        return "带孩(三男孩、一女孩)";
    } else if (marker === 40) {
        return "带孩(三男孩、俩女孩)";
    } else if (marker === 72) {
        return "带孩(三男孩、三女孩)";
    }
    return '无';
}


/**
 * 抽烟状况
 * 'smoking' 1=不抽烟 2=偶尔抽 4=经常抽 8=社交场合会抽烟
 *
 * @return
 */
export function getSmokingName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "不抽烟";
    } else if (marker === 2) {
        return "偶尔抽";
    } else if (marker === 4) {
        return "经常抽";
    } else if (marker === 8) {
        return "社交场合会抽烟";
    }
    return '不限';
}


/**
 * 喝酒
 * 'drinking' 1=不喝酒 2=偶尔喝酒 3=经常喝酒 4=社交场合会喝酒
 *
 * @return
 */
export function getDrinkingName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "不喝酒";
    } else if (marker === 2) {
        return "偶尔喝酒";
    } else if (marker === 4) {
        return "经常喝酒";
    } else if (marker === 8) {
        return "社交场合会喝酒";
    }
    return '不限';
}

/**
 * 是否会做饭
 * ''cooking'    1=不会做饭  2=厨艺一般 4=厨艺很好
 *
 * @return
 */
export function getCookingName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "不会做饭";
    } else if (marker === 2) {
        return "厨艺一般";
    } else if (marker === 4) {
        return "厨艺很好";
    }
    return '不限';
}


/**
 * 纹身:
 * 'tattoo'   1=没有纹身 2=小块纹身 4=大面积纹身
 * @return
 */
export function getTattooName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "没有纹身";
    } else if (marker === 2) {
        return "小块纹身";
    } else if (marker === 4) {
        return "大面积纹身";
    }
    return '不限';
}


/**
 * 是否愿意与父母同住:
 * live_with_parent'   1=愿意  2=不愿意与父母同住 4=都可以 8=视情况而定
 *
 * @return
 */
export function getLiveWithParentName(value) {
    let marker = parseInt(value);
    if (marker === 1) {
        return "愿意";
    } else if (marker === 2) {
        return "不愿意与父母同住";
    } else if (marker === 4) {
        return "都可以";
    } else if (marker === 8) {
        return "视情况而定";
    }
    return '不限';
}

/**
 * 是否为微信打开
 * @returns {boolean}
 */
export function isWeiXin(){
    let ua = navigator.userAgent.toLowerCase();
    if(ua.match(/micromessenger/i)=="micromessenger") {
        return true;
    } else {
        return false;
    }
}

/**
 * 是否为IOS设被
 */
export function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function isAndroid() {
    return /Android/.test(navigator.userAgent);
}

export function isWebView() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    // 检查是否包含特定的WebView标识
    return /wv|iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

export function verifyPhone(phone){
    let phoneRegex = /^[1][3-9][0-9]{9}$/;
    return phoneRegex.test(phone);
}
// 下载文件，自定义文件名称
export function downFile(url, fileName) {

    const x = new XMLHttpRequest()
    x.open('GET', url, true)
    x.responseType = 'blob'
    x.onload = function() {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = fileName
        a.click()
    }
    x.send()
}


